export default __webpack_public_path__ + "static/media/Tasset of Crimson Slaughter.4d86957d.jpg";